export default __webpack_public_path__ + "static/6833-a8ce31e317181f849e64f75854868141.jpg";